export default __webpack_public_path__ + "static/media/VLogo.e61e8b48.svg";